import { render, staticRenderFns } from "./formInfo.vue?vue&type=template&id=c4031dc8&"
import script from "./formInfo.vue?vue&type=script&lang=js&"
export * from "./formInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports